<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20.6 13.4h-7.2v7.2q-.1 1.3-1.4 1.4-1.3-.1-1.4-1.4v-7.2H3.4Q2.1 13.3 2 12q.1-1.3 1.4-1.4h7.2V3.4Q10.7 2.1 12 2q1.3.1 1.4 1.4v7.2h7.2q1.3.1 1.4 1.4-.1 1.3-1.4 1.4"
    />
  </svg>
</template>
